<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useLocationStore } from '@/stores/locationStore'
import VueJwtDecode from "vue-jwt-decode"

const locationStore = useLocationStore()
const locations = ref([] as any[]);
const currentLocation = ref("");

onMounted(async () => {
  if (localStorage.getItem('access_token') != null) {
    const token = localStorage.getItem('access_token')!
    const userdata = VueJwtDecode.decode(token);
    currentLocation.value = userdata.tid
  }
  await locationStore.getTenants()
  locations.value = locationStore.tenants.map((s:any) => ({text: s.name, value: s.id}));
})

const setTenant = async (e:any) => {
  await locationStore.setTenant(e).then((x:any) => {
    if (x != undefined) {
      localStorage.setItem("access_token", x.token);
      window.location.reload()
    }
  })
}
</script>

<template>
    <div v-if="locations?.length > 1">
        <el-select size="large" @change="setTenant" v-model="currentLocation" placeholder="Select Tenant">
            <el-option
                v-for="item in locations"
                :key="item.value"
                :label="item.text"
                :value="item.value"
            />
        </el-select>
    </div>
</template>